module.exports = "<div class=\"bottom loader\">&nbsp;</div>";